import NewClientPushNotification from './NewClientPushNotification';

export default NewClientPushNotification;
